import { useMemo } from 'react';
import {
  getOriginalPriceLabel,
  getDiscountedPriceLabel,
  getTotalRecurringPriceLabel,
} from 'src/utils/payments';
import { PlanFamily } from 'src/types';
import { useGetDisplayedPlan } from './useGetDisplayedPlan';

export const useGetPriceLabel = ({
  planFamily,
}: {
  planFamily: PlanFamily;
}) => {
  const { getDisplayedPlan } = useGetDisplayedPlan();
  const displayedPlan = getDisplayedPlan(planFamily);

  const discountedPriceLabel = useMemo(() => {
    return getDiscountedPriceLabel({ displayedPlan });
  }, [displayedPlan]);

  const originalPriceLabel = useMemo(() => {
    return getOriginalPriceLabel({ displayedPlan });
  }, [displayedPlan]);

  const totalRecurringPriceLabel = useMemo(() => {
    return getTotalRecurringPriceLabel({ displayedPlan });
  }, [displayedPlan]);

  return {
    discountedPrice: displayedPlan?.discounted_price,
    originalPriceLabel,
    discountedPriceLabel,
    finalPriceLabel: totalRecurringPriceLabel,
  };
};
